module.exports = __webpack_public_path__ + "media/images/emblems/Walliswil_bei_Niederbipp-coat_of_arms-68142406d3c20516235cd5be1ff7bf1c.svg";